'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _account_form = require('../components/account_form');

var _account_form2 = _interopRequireDefault(_account_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO
var Account = _react2.default.createClass({
    displayName: 'Account',
    render: function render() {
        return _react2.default.createElement(_account_form2.default, { id: 'account', className: 'clearfix' });
    }
});

var mapStateToProps = function mapStateToProps(store) {
    // const { orders, filter } = store.order;
    return {
        // orders,
        // filter,
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Account);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/account.js
// module id = 1571
// module chunks = 0